import { System, SystemQueries } from "ecsy";
import { LifeTimeData } from "../DataComponents/LifeTimeData";

export class LifeTimeSystem extends System {
  static queries: SystemQueries = {
    entities: {
      components: [LifeTimeData],
    },
  };

  execute(delta: number, time: number): void {
    this.queries.entities.results.forEach((entity) => {
      const lifeTime = entity.getMutableComponent(LifeTimeData);
      lifeTime.lifeTime -= delta;
      if (lifeTime.lifeTime < 0) {
        entity.remove();
      }
    });
  }
}
